import gql from 'graphql-tag';

import { AccountAddressFields } from '../../../../../graphql/fragments/account';

const accountAddresses = gql`
  fragment accountAddresses on Account {
    id
    addresses {
      ...AccountAddressFields
    }
  }
  ${AccountAddressFields}
`;

export default accountAddresses;
